import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ProductionKeyPerformanceIndicatorEvaluationWithData } from 'src/app/models/production-key-performance-indicator-evaluation.model';
import { CompanyProductDeploysFrequencyEvaluationData } from 'src/app/models/company-product-deploys-frequency-kpi-data.model';

@Component({
  selector: 'app-company-product-deploys-frequency-details',
  templateUrl: './company-product-deploys-frequency-details.component.html',
  styleUrl: './company-product-deploys-frequency-details.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyProductDeploysFrequencyDetailsComponent {
  kpiData = input.required<ProductionKeyPerformanceIndicatorEvaluationWithData>();

  detailsData = computed((): CompanyProductDeploysFrequencyEvaluationData | null => {
    const rawData = this.kpiData().data?.[0]?.data;
    return CompanyProductDeploysFrequencyDetailsComponent.isCompanyProductDeploysFrequencyEvaluationData(rawData) ? rawData : null;
  });

  worstGapDaysCount = computed((): number | null => this.detailsData()?.worst_gap_days_count ?? null);

  deploysCount = computed((): number => this.detailsData()?.deploys_count ?? 0);

  intervalsCount = computed((): number => this.detailsData()?.intervals.length ?? 0);

  private static isCompanyProductDeploysFrequencyEvaluationData(data: unknown): data is CompanyProductDeploysFrequencyEvaluationData {
    if (typeof data !== 'object' || data === null) {
      return false;
    }

    const candidate = data as Partial<CompanyProductDeploysFrequencyEvaluationData>;

    return (
      typeof candidate.deploys_count === 'number' &&
      typeof candidate.worst_gap_days_count === 'number' &&
      Array.isArray(candidate.intervals)
    );
  }
}
